import { Injectable } from '@angular/core';
import { getQueryParams } from '@pin-up-global/common';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { ApiService, ListResponse } from '@shared/abstraction';
import { Observable } from 'rxjs';
import { FeedbackRow, FeedbacksReq } from './feedbacks.abstraction';

@Injectable({ providedIn: 'root' })
export class FeedbacksApiService extends ApiService {
  readonly #apiController: string = '@api/support/feedbacks';
  isLoading$ = this._isLoading$;

  getFeedbacks(params: FeedbacksReq): Observable<ListResponse<FeedbackRow>> {
    return this._httpClient
      .get<ListResponse<FeedbackRow>>(`${this.#apiController}/`, {
        params: getQueryParams(params),
      })
      .pipe(manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$));
  }

  archiveFeedback(feedbackId: number): Observable<void> {
    return this._httpClient
      .delete<void>(`${this.#apiController}/${feedbackId}/`)
      .pipe(manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$));
  }
}
